import { isEventAddOn } from '@/utils/cart.utils'

/**
 * Sorts events such that add-ons for those events occur after the last occurrence of that event
 * <p>NOTE: assumes events are already sorted by timeslot</p>
 * @param events {LocalLineItemWithMeta[]} - list of events to be sorted
 */
export const sortAddOns = (events: LocalLineItemWithMeta[]): LocalLineItemWithMeta[] => {
  const {
    sortedEvents,
    addOns,
  } = events.reduce((filteredArrs, event) => {
    // splits event objects into event tickets and addOn tickets
    filteredArrs[event.category.meta?.some((meta) => isEventAddOn(meta)) ? 'addOns' : 'sortedEvents'].push(event)
    return filteredArrs
  }, {
    sortedEvents: [] as LocalLineItemWithMeta[],
    addOns: [] as LocalLineItemWithMeta[],
  })

  addOns.forEach((addOn) => {
    // find last occurrence of event
    const eventIdx = sortedEvents.map((event) => event.event.id)
      .lastIndexOf(addOn.event.id)
    // place add-on after event
    sortedEvents.splice(eventIdx + 1, 0, addOn)
  })

  return sortedEvents
}
